import { ModalDefaultMessage } from "@components/modals/modal-messages";
import { useState } from "react";

export function RaffleDefaultWordHowItWorksBuying() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessageKey, setModalMessageKey] = useState<string | null>(null);

  const handleModalOpen = (messageKey: string) => {
    setModalMessageKey(messageKey);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="row">
        {/* Customer / Rifeiro */}
        <div className="col-md-6 border-end">
          <div className="text-center border-bottom pb-2">
            <span className="h5">Rifeiro</span>
          </div>
          <ul className="d-flex flex-column gap-2 mt-2">
            <li>Cadastre-se na plataforma.</li>
            <li>
              Tipos de aquisição para a criação de rifa:
              <ol className="d-flex flex-column gap-2">
                <li>
                  <strong>Prévia:</strong> Você compra o direito de criar a rifa
                  e não há mais taxas para a plataforma (exceto{" "}
                  <span
                    className="text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleModalOpen("feeExternal")}
                  >
                    taxas externas
                  </span>
                  ).
                </li>
                <li>
                  <strong>Comissionada:</strong> Você paga, ou se enquadra na
                  isenção, uma taxa simbólica para a plataforma e a mesma recebe
                  um percentual por ticket vendido na referida rifa (consulte os
                  valores no momento da criação).
                </li>
              </ol>
            </li>
            <li>Selecione o tipo de rifa desejada.</li>
            <li>Configure e crie a sua rifa.</li>
            <li>
              Divulgue através do(s) link(s):
              <ol className="d-flex flex-column gap-2">
                <li>
                  <strong>Rifeiro:</strong>Pode divulgar pelo próprio link
                  particular de usuário, onde os usuários verão todas rifas do
                  mesmo, ou pelo link específico da rifa.
                </li>
                <li>
                  <strong>Afiliado:</strong>Terá seu link de indicação vinculado
                  a rifa, após permissão de afiliação do Rifeiro, para divulgar
                  e ganhar comissões de venda.
                </li>
              </ol>
            </li>
            <li>Venda e lucre.</li>
          </ul>
        </div>

        {/* Cliente / Buyer */}
        <div className="col-md-6">
          <div className="text-center border-bottom pb-2">
            <span className="h5">Clientes / Compradores</span>
          </div>
          <ul className="d-flex flex-column gap-2 mt-2">
            <li>Cadastram, ou se identificam, na plataforma.</li>
            <li>
              Visitam a página da rifa, podendo vir por links de Rifeiros,
              Afiliados ou Explorando no Site.
            </li>
            <li>Adquire o(s) Ticket(s) desejado(s).</li>
            <li>Torce pela sorte grande de ser sorteado.</li>
          </ul>
        </div>
      </div>

      {isModalOpen && modalMessageKey && (
        <ModalDefaultMessage
          messageKey={modalMessageKey}
          onClose={handleModalClose}
        />
      )}
    </>
  );
}
